export const getAccessToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const token = localStorage.getItem("okta-anonymous-access-token");
  if (token) {
    return { token };
  }
};

export const getRequiredSpecification = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const getRequiredPrice = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const vietnameseMonths = [
  "tháng Giêng",
  "tháng hai",
  "tháng ba",
  "tháng tư",
  "tháng năm",
  "tháng sáu",
  "tháng bảy",
  "tháng tám",
  "tháng chín",
  "tháng mười",
  "tháng mười một",
  "tháng mười hai",
];

export const getFormattedDate = (locale, d) => {
  const date = new Date(d);
  if (locale === "vn") {
    const month = vietnameseMonths[date.getMonth()];
    return `${month}, ${date.getFullYear()}`;
  }
  const month = date.toLocaleString("default", { month: "long" });
  return `${month} ${date.getDate()}, ${date.getFullYear()}`;
};

export const getLinkTarget = url => {
  const isExternal = url?.startsWith("http");

  return isExternal ? "_blank" : "_self";
};

export const getLinkTargetTab = tabinfo => {
  return tabinfo === "New Tab" ? "_blank" : "_self";
};

export const MAP_LABELS = {
  vn: {
    centerName: "Trung tâm trải nghiệm KOHLER",
    showroomName: "KOHLER Showroom",
    dearName: "Nhà phân phối ủy nhiệm",
    storelocatorButtonLabel: "Search",
    searchLabel: "Địa chỉ mua hàng",
  },
  en: {
    centerName: "Kohler Experience Center:",
    showroomName: "KOHLER Showroom",
    dearName: "Authorized KOHLER dealer",
    storelocatorButtonLabel: "Search",
    searchLabel: "Find a store",
  },
};
